module.exports = __webpack_public_path__ + "static/img/manual-14.0569237.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-14.png
// module id = kRr/
// module chunks = 4